
export const deltaEightRestrictedStates = [
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "KY",
  "ID",
  "IA",
  "MI",
  "MS",
  "MT",
  "NY",
  "NV",
  "ND",
  "OR",
  "RI",
  "UT",
  "VT",
  "WA",
]

export const thcaRestrictedStates = [
  "CA", "IN", "OR",
]

export const thcRestrictedStates = [
  "CA",
]
